import script from "./PartnerProjectManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerProjectManagement.vue?vue&type=script&setup=true&lang=js"

import "./PartnerProjectManagement.vue?vue&type=style&index=0&id=1c095e88&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c095e88"]])

export default __exports__